__turbopack_context__.v({
  "brand": "hero-module-scss-module__wqsnFq__brand",
  "headline": "hero-module-scss-module__wqsnFq__headline",
  "hero": "hero-module-scss-module__wqsnFq__hero",
  "mission": "hero-module-scss-module__wqsnFq__mission",
  "overlayBottom": "hero-module-scss-module__wqsnFq__overlayBottom",
  "overlayTop": "hero-module-scss-module__wqsnFq__overlayTop",
  "panel": "hero-module-scss-module__wqsnFq__panel",
  "panelWrap": "hero-module-scss-module__wqsnFq__panelWrap",
  "video": "hero-module-scss-module__wqsnFq__video",
});
